<template>
  <div>
    <v-card
      class="rounded-xl mt-5 px-5 py-3 category-card-hover"
      :key="'trainingCategory-' + trainingCategory._id"
      elevation="0"
      style="border: 1px solid #EBEBEB; transition: all 0.3s ease;"
    >
      <v-row align="center" class="text-start">
        <v-col cols="12" md="4" lg="4">
          <span class="text-start font-weight-medium text-subtitle-1 textLight--text text-ellipse-4">
            {{ getLocalisedValue(trainingCategory.name) }}
          </span>
        </v-col>

        <v-col cols="12" md="5" lg="5">
          <div
            v-if="
              trainingCategory.subCategories &&
              trainingCategory.subCategories.length
            "
          >
            <div style="overflow-y: auto; overflow-x: hidden; max-height: 125px" class="d-flex flex-wrap">
              <v-chip
                v-for="(trainingSubCategory, index) in trainingCategory.subCategories"
                :key="index"
                class="me-2 mb-2 rounded-lg font-weight-medium"
                color="primaryLight"
                text-color="primary"
                small
              >
                <span class="text-truncate" style="max-width: 150px;">
                  {{ getLocalisedValue(trainingSubCategory.name) }}
                </span>
              </v-chip>
            </div>
          </div>

          <span
            v-else
            class="text-start subtitle-1 textLight--text text-ellipse-2"
          >
            {{ $t("trainingCategory.noTrainingSubCategories") }}</span
          >
        </v-col>

        <v-col cols="12" md="3" lg="3">
          <div class="d-flex justify-end align-center" style="gap: 12px;">
            <template v-if="havePermissionUpdateTrainingCategory">
              <v-btn
                icon
                small
                color="primary"
                class="rounded-lg bg-primaryLight"
                @click="$emit('editTrainingCategory', trainingCategory)"
              >
                <v-icon size="18">mdi-pencil-outline</v-icon>
              </v-btn>
            </template>

            <template v-if="havePermissionEnableDisableTrainingCategory || havePermissionUpdateTrainingCategory">
              <v-switch
                flat
                dense
                hide-details
                inset
                color="success"
                v-model="trainingCategory.isActive"
                class="ma-0 pt-0"
                :loading="statusUpdateLoading"
                @change="value => updateOrDelete(value ? 'enable' : 'disable')"
              ></v-switch>
            </template>

            <template v-if="havePermissionDeleteTrainingCategory">
              <v-btn
                icon
                small
                color="error"
                class="rounded-lg bg-errorLight"
                @click="updateOrDelete('delete')"
              >
                <v-icon size="18">mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
          </div>
        </v-col>
      </v-row>
    </v-card>

  </div>
</template>

<script>
import { updateTrainingCategoryStatus } from "../methods/updateTrainingCategoryStatus";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  name: "CategoryCard",
  data() {
    return {
      statusUpdateLoading: false,
    };
  },
  props: {
    trainingCategory: {
      type: Object,
      required: true,
    },
  },
  computed: {
    havePermissionUpdateTrainingCategory() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["UPDATE_TRAINING_CATEGORY"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionEnableDisableTrainingCategory() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["ENABLE_DISABLE_TRAINING_CATEGORY"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionDeleteTrainingCategory() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DELETE_TRAINING_CATEGORY"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    async updateOrDelete(val) {
      if (val) {
        this.statusUpdateLoading = true;

        if (val === "enable") {
          let response = await updateTrainingCategoryStatus({
            _id: this.trainingCategory._id,
            isActive: true,
          });

          if (response) {
            this.statusUpdateLoading = false;

            if (response.error) {
              this.trainingCategory.isActive = false;
              this.$emit("updateErr");
            }
          }
        } else if (val === "disable") {
          let response = await updateTrainingCategoryStatus({
            _id: this.trainingCategory._id,
            isActive: false,
          });

          if (response) {
            this.statusUpdateLoading = false;

            if (response.error) {
              this.trainingCategory.isActive = true;
              this.$emit("updateErr");
            }
          }
        } else if (val === "delete") {
          this.$emit("deleteTrainingCategory", this.trainingCategory._id);
          this.statusUpdateLoading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.category-card-hover:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08) !important;
  border-color: transparent !important;
}
.bg-primaryLight {
  background-color: #F5F1FF !important;
}
.bg-errorLight {
  background-color: #FFF0F0 !important;
}
</style>
